<app-dialog-base [Title]='"Import"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()" [width]="'480px'" [height]="'300px'">
  <div class="inputgroup">
    <label>{{'Recreate the object if already exists'|translate}}</label>
    <input type="checkbox" [(ngModel)]="model.OverwriteExisting" />
  </div>
  <br/>
  <app-file-upload
    [accept]="'.zip,.wlp,.json'"
    [multiple]="false"
    [label]="'File' | translate"
    (filesSelected)="model.Content = $event?.item(0)">
  </app-file-upload>
</app-dialog-base>
